import React from 'react';
import style from './App.less';
import go from "./images/go.png";
class App extends React.PureComponent {
    componentDidMount(){
       
    }
    render(){
        console.log(this.props)
        return (
               <ul className={style.box}>
                    <li onClick={()=>{this.props.history.push("/userIntroduce")}}>
                       <span>多联机WIFI盒子使用说明书</span> 
                       <img src={go} alt=""/>
                    </li> 
                    <div className={style.line}></div>
                    <li onClick={()=>{this.props.history.push("/userAgreement")}}>
                       <span>TCL用户协议</span>
                       <img src={go} alt=""/>
                    </li>  
                    <li onClick={()=>{this.props.history.push("/privacyGDPR")}}>
                       <span>PrivacyGDPR</span>
                       <img src={go} alt=""/>
                    </li>  
                    <li onClick={()=>{this.props.history.push("/privacy")}}>
                       <span>privacy</span>
                       <img src={go} alt=""/>
                    </li>  
               </ul>
        )
    }
}
export default App;